import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const SubHeaderContainer = superstyled({
  name: 'ZuiSubHeaderContainer',
  slot: 'Root',
  tag: Stack,
  propsAdded: {
    gap: 2
  },
  styles: ({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
      width: '100%'
    }
  })
});

export const SubheaderText = superstyled({
  name: 'ZuiSubheader',
  slot: 'Root',
  tag: Text,
  propsAdded: {
    size: 'md'
  },
  styles: () => ({
    whiteSpace: 'pre-line'
  })
});

export const PartnerSection = superstyled({
  name: 'ZuiPartnerSection',
  slot: 'Root',
  tag: Stack,
  styles: ({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(3),
    height: '1.75rem',

    [theme.breakpoints.up('sm')]: {
      gap: theme.spacing(2)
    },

    [theme.breakpoints.up('lg')]: {
      justifyContent: 'flex-start'
    }
  })
});

export const PartnerReviewBlanks = superstyled({
  name: 'ZuiPartnerReviewBlanks',
  slot: 'Root',
  tag: Stack,
  styles: ({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5)
  })
});

export const PartnerImage = superstyled({
  name: 'ZuiReviewBlankItem',
  slot: 'Root',
  tag: SharedAsset,
  styles: () => ({
    height: '1.75rem'
  })
});
